import { render, staticRenderFns } from "./MatchVideo.vue?vue&type=template&id=eea24b62&scoped=true&"
import script from "./MatchVideo.vue?vue&type=script&lang=js&"
export * from "./MatchVideo.vue?vue&type=script&lang=js&"
import style0 from "./MatchVideo.vue?vue&type=style&index=0&id=eea24b62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea24b62",
  null
  
)

export default component.exports